import { PlayIcon } from "@heroicons/react/outline"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import config from "../lib/config"
import DemoVideoModal from "./demo-video-modal"

export default function Hero() {
  const [demoOpen, setDemoOpen] = useState(false)
  return (
    <div className="relative pb-10">
      {demoOpen ? (
        <DemoVideoModal closeModal={() => setDemoOpen(false)} />
      ) : null}
      <div className="max-w-7xl mx-auto">
        <div className="relative sm:rounded-2xl flex flex-col-reverse md:flex-row">
          <div className="sm:px-6 xl:px-0 relative z-20 flex-1 py-8 sm:py-18 lg:py-24">
            <div className="px-6 sm:px-0 sm:w-11/12">
              <h1 className="text-4xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                <span className="block text-gray-800 mb-1.5">
                  A better way to
                </span>
                <span className="block text-default-600">
                  respond to emergencies
                </span>
              </h1>
              <p className="mt-6 max-w-lg text-xl text-gray-400 sm:max-w-5xl">
                {config.siteTitle} is an emergency response platform for schools
                that{" "}
                <span className="text-gray-500 font-medium">
                  streamlines emergency response
                </span>{" "}
                and helps{" "}
                <span className="text-gray-500 font-medium">
                  keep students safe
                </span>
                .
              </p>
              <div className="mt-10 max-w-sm sm:max-w-none sm:flex">
                <div className="space-y-4 xl:space-y-0 xl:inline-grid sm:grid-cols-2 sm:gap-5">
                  <Link
                    to="/request-a-demo"
                    className="transition-all w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-default-600 hover:bg-default-700 md:py-4 md:text-lg md:px-10"
                  >
                    Request a Demo
                  </Link>
                  <button
                    onClick={() => setDemoOpen(true)}
                    className="transition-all w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-default-700 bg-default-200 hover:bg-default-300 md:py-4 md:text-lg md:px-10 outline-none focus:outline-none"
                  >
                    <PlayIcon className="h-8 mr-2" /> <span>Take a Tour</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="relative flex z-20 flex-1 items-center justify-center sm:pr-6 xl:pr-0">
            <div className="relative sm:max-w-lg sm:mx-auto lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
              <svg
                className="hidden md:block absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-8 scale-75 origin-top sm:scale-100 lg:hidden"
                width={640}
                height={784}
                fill="none"
                viewBox="0 0 640 784"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="4f4f415c-a0e9-44c2-9601-6ded5a34a13e"
                    x={118}
                    y={0}
                    width={20}
                    height={20}
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x={0}
                      y={0}
                      width={4}
                      height={4}
                      className="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  x={118}
                  width={404}
                  height={784}
                  fill="url(#4f4f415c-a0e9-44c2-9601-6ded5a34a13e)"
                />
              </svg>
              <div className="relative mx-auto w-full transform sm:scale-110">
                <button
                  type="button"
                  className="relative block w-full bg-white overflow-hidden focus:outline-none"
                  onClick={() => setDemoOpen(true)}
                >
                  <span className="sr-only">Watch our video to learn more</span>
                  <StaticImage
                    src="../images/thumbnail-v2.png"
                    width={1000}
                    alt="Demo Video Thumbnail"
                    placeholder="blurred"
                    className="w-full block"
                  />
                  <div
                    className="transition-all absolute inset-0 w-full h-full opacity-75 hover:opacity-100"
                    aria-hidden="true"
                  >
                    <svg
                      style={{
                        position: "absolute",
                        left: "42.5%",
                        top: "42.5%",
                        transform: "translate(-50%, -50%)",
                      }}
                      className="h-20 w-20 text-default-600"
                      fill="white"
                      viewBox="0 0 84 84"
                    >
                      <circle
                        opacity="0.9"
                        cx={42}
                        cy={42}
                        r={42}
                        fill="currentColor"
                      />
                      <path d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z" />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
